import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i3 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
function CoolLoadingButtonComponent_mat_spinner_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("color", ctx_r0.spinnerColor)("diameter", 20);
  }
}
const _c0 = ["*"];
let CoolLoadingButtonComponent = /*#__PURE__*/(() => {
  class CoolLoadingButtonComponent {
    constructor(_changeDetector) {
      this._changeDetector = _changeDetector;
      this.loadingChanged = new EventEmitter();
      this.loadingFinished = new EventEmitter();
      this.innerClass = '';
    }
    async onClick() {
      if (this.disabled || this.isLoading || !this.clickHandler) {
        return;
      }
      try {
        this._changeIsLoading(true);
        await Promise.resolve(this.clickHandler(this.clickParameters));
      } finally {
        this._changeIsLoading(false);
        this.loadingFinished.next();
      }
    }
    _changeIsLoading(loadingValue) {
      this.isLoading = loadingValue;
      this.loadingChanged.next(this.isLoading);
      this._changeDetector.markForCheck();
    }
  }
  CoolLoadingButtonComponent.ɵfac = function CoolLoadingButtonComponent_Factory(t) {
    return new (t || CoolLoadingButtonComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
  };
  CoolLoadingButtonComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CoolLoadingButtonComponent,
    selectors: [["cool-loading-button"]],
    inputs: {
      color: "color",
      spinnerColor: "spinnerColor",
      disabled: "disabled",
      clickHandler: "clickHandler",
      clickParameters: "clickParameters",
      innerClass: ["class", "innerClass"]
    },
    outputs: {
      loadingChanged: "loadingChanged",
      loadingFinished: "loadingFinished"
    },
    ngContentSelectors: _c0,
    decls: 4,
    vars: 6,
    consts: [["mat-raised-button", "", 3, "color", "disabled", "click"], [1, "button-content-container"], ["class", "spinner", 3, "color", "diameter", 4, "ngIf"], [1, "spinner", 3, "color", "diameter"]],
    template: function CoolLoadingButtonComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function CoolLoadingButtonComponent_Template_button_click_0_listener() {
          return ctx.onClick();
        });
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, CoolLoadingButtonComponent_mat_spinner_2_Template, 1, 2, "mat-spinner", 2);
        i0.ɵɵprojection(3);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.innerClass);
        i0.ɵɵproperty("color", ctx.color)("disabled", ctx.disabled || ctx.isLoading);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isLoading);
      }
    },
    dependencies: [i1.NgIf, i2.MatButton, i3.MatProgressSpinner],
    styles: [".spinner[_ngcontent-%COMP%]{display:inline-block;margin-right:.5rem}.button-content-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center}"],
    changeDetection: 0
  });
  return CoolLoadingButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CoolLoadingButtonModule = /*#__PURE__*/(() => {
  class CoolLoadingButtonModule {}
  CoolLoadingButtonModule.ɵfac = function CoolLoadingButtonModule_Factory(t) {
    return new (t || CoolLoadingButtonModule)();
  };
  CoolLoadingButtonModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CoolLoadingButtonModule
  });
  CoolLoadingButtonModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule]
  });
  return CoolLoadingButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of loading-button
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CoolLoadingButtonComponent, CoolLoadingButtonModule };
